import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { Menu, Item } from "@appetize/iw-common/interfaces/menu/menu";
import spinnerInterceptor from "../interceptors/spinner.interceptor";
import authTokenInterceptor from "../interceptors/auth-token-iw.interceptor";

const http: AxiosInstance = axios.create({
  baseURL: window.location.origin,
  headers: {
    "Content-Type": "application/json"
  }
});

authTokenInterceptor.wrapAxios(http);
spinnerInterceptor.wrapAxios(http);

function fetchIWVendorMenu(venueId: string, vendorId: string): Promise<AxiosResponse<Menu>> {
  return http.get(`/venues/${venueId}/vendors/${vendorId}/menu`, {
    showSpinner: true,
    applyToken: true
  } as AxiosRequestConfig);
}

function fetchIWVendorMenuItemById(venueId: string, vendorId: string, itemId: string): Promise<AxiosResponse<Item>> {
  return http.get(`/venues/${venueId}/vendors/${vendorId}/menu/items/${itemId}`, {
    showSpinner: true,
    applyToken: true
  } as AxiosRequestConfig);
}

function fetchIWVendorMenuItemsByIds(venueId: string, vendorId: string, itemIds: string[]): Promise<AxiosResponse<Item>> {
  const itemIdsQueryString = itemIds.join(",");
  return http.get(`/venues/${venueId}/vendors/${vendorId}/menu/items?ids=${itemIdsQueryString}`, {
    showSpinner: true,
    applyToken: true
  } as AxiosRequestConfig);
}

function fetchIWVendorMenuItemByExternalId(venueId: string, vendorId: string, barcode: string): Promise<AxiosResponse<Item>> {
  return http.get(`/venues/${venueId}/vendors/${vendorId}/menu/items?barcode=${barcode}`, {
    showSpinner: true,
    applyToken: true
  } as AxiosRequestConfig);
}

export default {
  fetchIWVendorMenu,
  fetchIWVendorMenuItemById,
  fetchIWVendorMenuItemsByIds,
  fetchIWVendorMenuItemByExternalId
};
